import { render } from "./WhatWeDo.vue?vue&type=template&id=1fe8e2bc&scoped=true"
import script from "./WhatWeDo.vue?vue&type=script&lang=js"
export * from "./WhatWeDo.vue?vue&type=script&lang=js"

import "./WhatWeDo.vue?vue&type=style&index=0&id=1fe8e2bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe8e2bc"]])

export default __exports__